export const Pagination = {
  maxResultCount: 20,
  skipCount: 20,
}